import { render } from "./HelpDialog.vue?vue&type=template&id=2452f162&scoped=true"
import script from "./HelpDialog.vue?vue&type=script&lang=js"
export * from "./HelpDialog.vue?vue&type=script&lang=js"

import "./HelpDialog.vue?vue&type=style&index=0&id=2452f162&scoped=true&lang=css"

import exportComponent from "/tmp/builds/1syD-sny/0/plataforma/frontend/side_panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2452f162"]])

export default __exports__